/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowpictureshint3Inputs */

const en_aiflowpictureshint3 = /** @type {(inputs: Aiflowpictureshint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up to three pictures, also with Ctrl+V or by dragging them here. A flyer is read too.`)
};

const de_aiflowpictureshint3 = /** @type {(inputs: Aiflowpictureshint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis zu drei Bilder, auch mit Strg+V oder hierher ziehen. Ein Flyer wird mitgelesen.`)
};

/**
* | output |
* | --- |
* | "Up to three pictures, also with Ctrl+V or by dragging them here. A flyer is read too." |
*
* @param {Aiflowpictureshint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowpictureshint3 = /** @type {((inputs?: Aiflowpictureshint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowpictureshint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowpictureshint3(inputs)
	return de_aiflowpictureshint3(inputs)
});
export { aiflowpictureshint3 as "aiFlowPicturesHint" }